import { Moon, Sun } from 'lucide-react';
import { useThemeStore } from '@/stores/theme';

/** Alterna rápido claro/escuro no cabeçalho. O modo "Sistema" fica em Config → Aparência. */
export function ThemeToggle() {
  const resolved = useThemeStore((s) => s.resolved);
  const setPreference = useThemeStore((s) => s.setPreference);
  const isDark = resolved === 'dark';
  return (
    <button
      type="button"
      onClick={() => setPreference(isDark ? 'light' : 'dark')}
      aria-label={isDark ? 'Usar tema claro' : 'Usar tema escuro'}
      title={isDark ? 'Tema claro' : 'Tema escuro'}
      className="grid size-11 place-items-center rounded-full text-muted transition-colors hover:bg-canvas lg:size-9"
    >
      {isDark ? <Sun className="size-5" /> : <Moon className="size-5" />}
    </button>
  );
}
